import React from "react";
import { useAppState } from "../../../Redux/ReduxHooks";

/**
 * Displays the booking reference number for bookings made through voice channels (e.g. IVR, Contact center). This is read only.
 */
export const BookingReference: React.FC = () => {

    const bookingRef = useAppState(state => state.PhoneToCnp.Booking?.DispatchBookingId);

    return (
        <div className="booking-reference">
            <div className="booking-ref">{`Ref: ${bookingRef}`}</div>
        </div>
    )
}